import React, { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import Table, { EmptyPrimeVendorAllocation, IPrimeVendorAllocation } from "./Table";
import Form from "./Form";
export interface IModal {
  singleData: IPrimeVendorAllocation;
  open: boolean;
}

const PrimeVendorAllocation = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
  const [reload, setReload] = useState(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ open: false, singleData: EmptyPrimeVendorAllocation });
  };
  return (
    <>
      <Table permissions={permissions} reload={reload} setModal={setModal} toast={toast} setReload={setReload} />
      <Form  singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default PrimeVendorAllocation;
